import TopNav from '../components/TopNav'
import LandingPage from '../views/landing-page/Index'
import PlaceHolderLoader from "../components/reusables/PlaceHolderLoader";
import PopOver from "../components/reusables/PopOver";
import CircularProgress from "../components/reusables/CircularProgress";
import DateRangePicker from "../components/reusables/DateRangePicker"
import AdminLayout from "../views/layouts/AdminLayout.vue";
import ApiPlayground from "../components/api-playground/Index.vue"
import ModalWithSlot from '../views/admin/jobs/job-management/applicant-tracking-system/includes/modals/ModalWithSlot.vue';
import OldModalWithSlot from '../views/admin/jobs/job-management/applicant-tracking-system/includes/modals/OldModalWithSlot.vue';
import SidePanelModal from '../views/admin/jobs/job-management/applicant-tracking-system/includes/modals/SidePanelModal.vue';
import IdmsAuth from '../views/auth/ui/IdmsAuth.vue';

const Components = {
    TopNav,
    LandingPage,
    PopOver,
    ApiPlayground,
    PlaceHolderLoader,
    AdminLayout,
    ModalWithSlot,
    SidePanelModal,
    CircularProgress,
    DateRangePicker,
    OldModalWithSlot,
    IdmsAuth
};

Object
    .keys(Components)
    .forEach(name => {
        Vue.component(name, Components[name]);
    });

export default Components;
